import { InvalidTokenException, UnknownException } from "./exceptions.js";

export const interceptResponse = (response, source) => {
    console.log(response.status)
    switch(response.status){
        case 401 : 
            throw new InvalidTokenException(source, 'INVALID or EXPIRED')
        case 200 :
            return response;
        case 500 : 
            throw new UnknownException(source)
        default: return response;
    }
}

export const isTokenValid = (token) => {
    try{
    const base64Url = token.split(".")[1];
    let base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    base64 = base64Url.padEnd(
        base64Url.length + ((4 - (base64Url.length % 4)) % 4),
        "="
      );
    const rawData = atob(base64);
    const decoder = new TextDecoder("utf-8");
    const decodedToken = decoder.decode(
        new Uint8Array([...rawData].map((char) => char.charCodeAt(0)))
      );
    const parsedDecodedToken = JSON.parse(decodedToken);
    const expirationTimestamp = parsedDecodedToken.exp;
    const currentTimestamp = Math.floor(Date.now() / 1000);
    return expirationTimestamp > currentTimestamp ? true : 'EXPIRED'
    }
    catch(err){
        return 'INVALID'
    }
}

export async function mic() {
    let result = await navigator.permissions.query({ name: "microphone" });
    console.log(result);
}

export const SessionType = {
    Incoming: "Incoming",
    Outgoing: "Outgoing",
}